<template>
  <v-app id="duorol-page">
    <Menu />
    <v-container id="duorol" grid-list-lg>
     
        <v-layout row wrap>

          <!-- Afmetingen Block -->
          <v-flex xs12>
            <v-form ref="phaseOne" @submit.prevent="goToPhaseTwo">
              <v-card class="card-expansion" :disabled="true">
                <v-toolbar @click="phaseOne" class='elevation-0'
                  :class="stepOne + stepOneActive ? 'panel-open' : 'product-panel'">
                  <img
                    :src="stepOne + stepOneActive ? require('../assets/ui-elements/step1-active.png') : require('../assets/ui-elements/step1.png')"
                    alt="">
                  <v-card-title dark> <span class="sub-title"
                      :class="stepOne + stepOneActive ? 'step-tile-active' : 'step-title'">Afmetingen</span>
                  </v-card-title>
                  <v-spacer></v-spacer>
                  <h4 class="mr-5 text-truncate activeProductTitle">B {{width}} x H {{height}} mm</h4>
                  <v-icon :class="stepOne + stepOneActive ? 'step-icon-active' : ''">{{toggleIcon(stepOne)}}
                  </v-icon>
                </v-toolbar>
                <transition name="expand">
                  <v-card-text v-if="stepOne">
                    <v-container grid-list-xs>
                      <v-layout row wrap>

                        <!-- Breedte -->
                        <v-flex xs12 sm4 md3>
                          <v-layout id="height-help" row wrap>
                            <v-flex xs12 sm12 md12 lg12>
                              <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12>
                              <img max-height="60px" :src="require('../assets/gordijnen/extra/width-arrow.png')" />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex class="height" xs12 sm7 md8>
                          <v-slider @input="sliderInput" v-model="width" :max="maxWidth"></v-slider>
                          <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                          <v-flex class="max" xs6 text-xs-right>Max {{maxWidth}} mm</v-flex>
                        </v-flex>

                        <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                          <span class="info-height mr-2">Breedte</span>
                          <div class="sizeRange">
                            <v-text-field outline v-model="width" type="number"></v-text-field>
                          </div> <span class="ml-2 info-height">mm</span>
                        </v-flex>

                        <!-- Hoogte -->
                        <v-flex xs12 sm4 md3>
                          <v-layout id="height-help" row wrap>
                            <v-flex xs5 sm4 md5 lg3>
                              <img max-height="60px" :src="require('../assets/gordijnen/extra/width-example.png')" />
                            </v-flex>
                            <v-flex xs1 sm7 md2 lg3 text-xs-left>
                              <img max-width="60px" :src="require('../assets/gordijnen/extra/height-arrow.png')" />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex class="height" xs12 sm7 md8>
                          <v-slider @input="sliderInput" v-model="height" :max="maxHeight"></v-slider>
                          <v-flex class="min" xs6 text-xs-left>Min 250 mm</v-flex>
                          <v-flex class="max" xs6 text-xs-right>Max {{maxHeight}} mm</v-flex>
                        </v-flex>

                        <v-flex class="size-unit" text-xs-center xs12 sm6 offset-sm4 md6 offset-md4>
                          <span class="info-height mr-2">Hoogte</span>
                          <div class="sizeRange">
                            <v-text-field outline v-model="height" type="number"></v-text-field>
                          </div> <span class="ml-2 info-height">mm</span>
                        </v-flex>

                      
                        <v-flex v-if="error" xs12>
                          <h4 class="error--text font-weight-light">{{errorMsg}}</h4>
                        </v-flex>
                        <v-flex xs12 text-xs-right>
                          <v-btn type="submit" class="next-step text-none" color="primary" flat outline>Volgende
                            stap <v-icon right>fal fa-chevron-right</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </transition>
              </v-card>
            </v-form>
          </v-flex>

          <!-- Totaal Block -->
          <v-flex xs12>
             <v-form @submit.prevent="submitForm" ref="duoRolForm">
            <v-card class="card-expansion" :disabled="true">
              <v-toolbar @click="phaseTwo" class='elevation-0' :class="stepTwo ? 'panel-open' : 'product-panel'">
                <img
                  :src="stepTwo  ? require('../assets/ui-elements/step2-active.png') : require('../assets/ui-elements/step2.png')"
                  alt="">
                <v-card-title dark> <span class="sub-title"
                    :class="stepTwo ? 'step-tile-active' : 'step-title'">Totaal</span>
                </v-card-title>
                <v-spacer></v-spacer>
 <h4 class="mr-5 text-truncate activeProductTitle">&#8364; {{totalPrice | currency}}</h4>
                <v-icon :class="stepTwo ? 'step-icon-active' : ''">{{toggleIcon(stepTwo)}}
                </v-icon>
              </v-toolbar>
              <transition name="expand">
                <v-card-text v-if="stepTwo">
                  <v-container grid-list-xs>
                    <v-layout row wrap>


                      <!-- Afmetingen -->
                      <v-flex xs4 sm2 md2><span class="total-title">Afmeting:</span></v-flex>
                      <v-flex xs8 sm10 md10><span class="total-item">Breedte {{width}} mm x Hoogte
                          {{height}} mm </span></v-flex>

                      <!-- Ruimte/Raam + Totale Prijs & Button -->
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs4 sm2 md2><span class="total-title">Aantal</span></v-flex>
                          <v-flex xs6 sm10 md10>
                            <v-text-field class="quantity-input" :rules="quantityRules" v-model="quantity" type="number"
                              outline></v-text-field>
                          </v-flex>
                          <v-flex xs4 sm2 md2>
                            <span class="total-title">Ruimte / raam</span>
                          </v-flex>
                          <v-flex xs8 sm8 md8>
                            <v-text-field class='price-input' v-model="room" type="text" outline
                              label="Typ hier een naam voor de ruimte of het raam">
                            </v-text-field>
                          </v-flex>
                          <v-flex text-xs-center xs12>
                            <hr class="seperator-line">
                          </v-flex>
                          <v-flex xs2 text-xs-left>
                            <span class="end-total-title">Totaal</span>
                          </v-flex>
                          <v-flex xs10 text-xs-right>
                            <h2 class="price-total"> <span class="price-title mr-3">Prijs compleet,
                                incl. BTW </span> €
                              {{totalPrice | currency}}</h2>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </transition>
            </v-card>
            <v-flex id="col-btn" xs12 text-xs-right>
              <v-btn type="submit" color="primary" depressed class="text-none form-btn">Plaats op lijst
                <v-icon class="icon-size" right>fal fa-plus</v-icon>
              </v-btn>
            </v-flex>
             </v-form>
          </v-flex>
        </v-layout>

    </v-container>
    <SnackBar v-model="snackbar" :text="messageTxt" :color="color" />
  </v-app>
</template>


<script>
import Menu from '@/components/Menu';
import Messages from '@/services/messages.service'; // Meldingen
import SnackBar from '@/components/SnackBar';
import ApiService from '@/services/api.service'; // Api Service
import FormatService from '@/services/format.service'; // Filters

export default {
  components: {
    Menu,
    SnackBar
  },
  data() {
    return {
      active: false,
      stepOne: false,
      stepOneActive: false,
      stepTwo: false,
      height: null,
      width: null,
      max: 10000,
      maxWidth: 2750,
      maxHeight: 2800,
      quantity: 1,
      room: '',
      price: 0,
      productPrijs: 0,
      error: false,
      errorMsg: '',
      snackbar: false,
      color: '',
      messageTxt: '',
      quantityRules: [quantity => !!quantity || Messages.QuantityValidationMessage],

    }
  },
  computed: {
    totalPrice() {
      return this.quantity * this.productPrijs
    }
  },
  methods: {
    getPrice() {
      if (this.width > 249 && this.height > 249) {
        ApiService.getDuorolPrice({
          breedte: this.width,
          hoogte: this.height
        }).then(response => {
          this.productPrijs = response;
        })
      }
    },
    phaseOne() {
      this.stepOne = !this.stepOne;
    },
    phaseTwo() {
      this.stepTwo = !this.stepTwo;
    },
    goToPhaseTwo() {
      if (this.width > 249 && this.height > 249) {
        this.stepOne = false;
        this.stepTwo = true;
        this.stepOneActive = true;
        this.getPrice()
      } else {
        this.error = true;
        this.errorMsg = Messages.SizesValidationMessage;
      }
    },
    submitForm() {
      if (this.width > 249 && this.height > 249 && this.$refs.duoRolForm.validate()) {
        ApiService.getDuorolPrice({
          breedte: this.width,
          hoogte: this.height
        }).then(response => {
          this.productPrijs = response;
          this.stepTwo = false;
          this.stepOneActive = false;
          this.snackbar = true;
          this.color = '#006fb3';
          this.messageTxt = Messages.ProductAddedMessage;
          this.$store.dispatch('products/addProduct', {
            naam: this.$router.history.current.name,
            breedte: this.width,
            hoogte: this.height,
            hoeveelheid: this.quantity,
            ruimte: this.room,
            totaleprijs: this.quantity * this.productPrijs
          })
        })
      } else {
        this.snackbar = true;
        this.color = '#FF5252';
        this.messageTxt = Messages.NoProductsMessage;
      }
    },
    sliderInput(value) {
      if (value > 249) {
        this.error = false;
      }
    },
    toggleIcon(value) {
      if (value) {
        return 'fal fa-minus-circle';
      } else {
        return 'fal fa-plus-circle';
      }
    },
  },
  filters: {
    ...FormatService
  }
}
</script>



<style scoped>

#duorol-page {
    background-color: #fff;
}

.card-expansion {
    box-shadow: none;
    border: 1px solid #eaeaea;
}

.type-extra-title {
    color: #006fb3;
    font-size: 15px;
    font-weight: 700;
}

.min {
    padding: 0 !important;
    margin: 0 !important;
    position: relative;
    top: 0;
    left: 0;
    left: -5%;
    top: -15%;
    color: #b4b4b4;
    font-size: 12px;
    font-weight: 400;
}

.max {
    padding: 0 !important;
    margin: 0 !important;
    position: relative;
    clear: both;
    right: -55%;
    top: -34%;
    color: #b4b4b4;
    font-size: 12px;
    font-weight: 400;
}

.sizeRange {
    border-radius: 4px;
    display: inline-block;
    width: 120px;
    height: 60px;
    position: relative;
    top: -1em;
    padding: 1em;
    vertical-align: middle;
    line-height: 60px;
}

.info-height {
    color: #707070;
    font-size: 16px;
    font-weight: 400;
}

.size-unit {
    position: relative;
    top: -3em;
    line-height: 30px;
    text-align: center;
}

.product-panel {
    border-top: 3px solid #b4b4b4;
    background-color: #fff;
}

.panel-open {
    border-top: 3px solid #006fb3;
    background-color: #fff;
}

.step-title {
    font-size: 15px;
    font-weight: 700;
    color: #b4b4b4;
}

.step-tile-active {
    font-size: 15px;
    font-weight: 700;
    color: #006fb3;
}

.step-icon-active {
    color: #006fb3;
}

.next-step {
    border-radius: 4px;
    height: 60px;
}

.activeProductTitle {
    color: #b4b4b4;
    font-size: 16px;
    font-weight: 400;
}

.product-tile {
    border: 1px solid #d0d0d0;
}

.product-tile-title {
    font-weight: 400;
    font-size: 19px;
    color: #707070;
}

.gordijnen-product-image {
    position: relative;
    right: 10px;
    width: 25%;
    height: 25%;
}

.selected {
    border: 2px solid #006fb3;
}

.plooi-selected {
    border: 2px solid #006fb3 !important;
}

.seperator-line {
    border: 1px solid #b4b4b4;
}


.total-title {
    color: #006fb3;
    font-size: 13px;
    font-weight: 700;
}

.price-title {
    color: #006fb3;
    font-size: 13px;
    font-weight: 700;
}


.total-item {
    color: #707070;
    font-size: 13px;
    font-weight: 400;
}

#addToCart {
    border-radius: 4px;
    height: 60px;
    margin: 0 !important;
}

.price-total {
    font-size: 15px;
    color: #006fb3;
    font-weight: 700;
}

.end-total-title {
    font-size: 15px;
    color: #006fb3;
    font-weight: 700;
}

.form-btn {
    border-radius: 4px;
    height: 60px;
    margin: 0 !important;
    width: 180px;
}

.icon-size {
    font-size: 20px;
}

#col-btn {
    padding-right: 0;
    padding-left: 0;
}

@media screen and (max-width: 1024px) {
    .plooi-product-image {
        width: 80%;
    }
}

@media screen and (max-width: 425px) {
    .size-unit {
        position: relative;
        top: -2.5em;
    }

    .form-btn {
        width: 100%;
    }

    #height-help {
        margin: 0 auto;
        text-align: center;
        justify-content: center;
    }

    .info-height {
        font-size: 13px;
    }

    .activeProductTitle {
        font-size: 14px;
    }

    #addToCart {
        width: 100%;
    }

}

@media screen and (max-width: 320px) {
    .size-unit {
        position: relative;
        top: -3em;
    }

    .activeProductTitle {
        display: none;
    }

}
</style>
